









/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { IPersonWithEmail } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'CustomerPickerDisplay',

  props: {
    customer: {
      type: Object as () => IPersonWithEmail,
      required: true,
    },
    showCaretDown: {
      type: Boolean,
      default: false,
    },
  },
})
